import { __extends } from "tslib";
import { GetApnsSandboxChannelRequest, GetApnsSandboxChannelResponse } from "../models/models_0";
import { deserializeAws_restJson1GetApnsSandboxChannelCommand, serializeAws_restJson1GetApnsSandboxChannelCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetApnsSandboxChannelCommand = /** @class */ (function (_super) {
    __extends(GetApnsSandboxChannelCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetApnsSandboxChannelCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetApnsSandboxChannelCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PinpointClient";
        var commandName = "GetApnsSandboxChannelCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: GetApnsSandboxChannelRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetApnsSandboxChannelResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetApnsSandboxChannelCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1GetApnsSandboxChannelCommand(input, context);
    };
    GetApnsSandboxChannelCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1GetApnsSandboxChannelCommand(output, context);
    };
    return GetApnsSandboxChannelCommand;
}($Command));
export { GetApnsSandboxChannelCommand };
//# sourceMappingURL=GetApnsSandboxChannelCommand.js.map